/* JUSTPRESS product pages (design + space pack). Progressive enhancement only; no engine logic.
   1. Add-to-set mode (?jp_add_to_set=1), as the live jp-ux-130.js did on design pages: "more like this" links keep the
      flag, the back link and the add-to-set return point go to the library in add-to-set mode.
   2. Brand words the engine prints stay untranslated (translate="no"), as jp-ux-130.js did.
   3. Space pack: a pack row opens the engine's package sheet (jp-visual-system-124.js) with that row's plan
      preselected, and the row of the current plan is marked. Load on design and pack pages, after the engine. */
(function () {
  'use strict';
  if (window.jpProductReady) return;
  window.jpProductReady = true;

  function withFlag(href) {
    try {
      var u = new URL(href, location.origin);
      if (u.origin !== location.origin) return href;
      u.searchParams.set('jp_add_to_set', '1');
      return u.pathname + u.search + u.hash;
    } catch (e) { return href; }
  }

  function addToSetMode() {
    if (new URLSearchParams(location.search).get('jp_add_to_set') !== '1') return;
    var lib = window.jpRoutes && window.jpRoutes.library;
    [].forEach.call(document.querySelectorAll('.jpd .jp-product-similar a'), function (a) { a.href = withFlag(a.href); });
    var back = document.querySelector('.jpd .jp-product-back');
    if (back && lib) back.href = withFlag(lib);
  }

  function noTranslate() {
    [].forEach.call(document.querySelectorAll('.jp-p0-spaces,[data-jp-p0-step="cart"]'), function (n) { n.setAttribute('translate', 'no'); });
  }

  function markPlan() {
    var rows = document.querySelectorAll('.jpk [data-jp-pack-plan]');
    if (!rows.length || !window.JPState || !window.JPState.read) return;
    var plan = '';
    try { plan = window.JPState.read().plan || ''; } catch (e) { return; }
    [].forEach.call(rows, function (b) {
      var on = b.getAttribute('data-jp-pack-plan') === plan;
      b.classList.toggle('on', on);
      if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
  }

  // Runs after the package root's own click handler (that one opened the sheet with the saved plan selected).
  document.addEventListener('click', function (e) {
    var row = e.target.closest && e.target.closest('.jpk [data-jp-pack-plan][data-jp-package-open]');
    if (!row) return;
    var root = row.closest('[data-jp-package-root]');
    var sheet = root && root.querySelector('[data-jp-package-sheet]');
    var pick = sheet && sheet.querySelector('[data-jp-package-plan="' + row.getAttribute('data-jp-pack-plan') + '"]');
    if (pick && !pick.disabled && !sheet.hidden) pick.click();
  });

  // 2.4.10c: a pack link with ?variant= (Google Shopping) lands on that pack: the server already shows its price and
  // spaces; here the saved plan follows it so the readouts don't switch back. Never shrinks a set that wouldn't fit.
  function landingPlan() {
    var top = document.querySelector('.jpk-top[data-jp-pack-sel]'), S = window.JPState;
    if (!top || !S || !S.read || !S.setPlan || !S.getPlan) return;
    var id = top.getAttribute('data-jp-pack-sel');
    try {
      var st = S.read() || {}, cap = Number((S.getPlan(id) || {}).capacity) || 0;
      var used = (st.items || []).reduce(function (a, it) { return a + (Number(it.spaces) || 0) * (Number(it.quantity) || 1); }, 0);
      if (cap > 0 && used <= cap) S.setPlan(id, 'landing-variant');
    } catch (e) {}
  }

  function init() { addToSetMode(); noTranslate(); landingPlan(); markPlan(); }
  document.addEventListener('justpress:state-change', markPlan);
  window.addEventListener('storage', markPlan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Design page, prototype R26b: size row + "Choose a size", "Add to set · N spaces" (straight into the set, flies to
   the set bar), Save / Saved label, "How big is …" (3D body, loaded when the section nears the screen), the set
   fill ("N spaces left in your $X set", from the visitor's real set) and "Read more". Sizes come from the size
   contract (JPSet.sizes); nothing here writes anything the engine does not write for a library design. */
(function () {
  'use strict';
  var root = document.querySelector('.jpd[data-jp-p0-root]');
  if (!root || window.jpDesignReady) return;
  window.jpDesignReady = true;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function sub(str, vars) { str = String(str || ''); Object.keys(vars).forEach(function (k) { str = str.split('%' + k).join(String(vars[k])); }); return str; }
  function J() { return window.JPSet; }
  function inches(l) { var m = String(l || '').match(/([\d.]+)\s*[×x]\s*([\d.]+)/); return m ? [parseFloat(m[1]), parseFloat(m[2])] : [0, 0]; }
  function nb(l) { return String(l || '').replace(/ IN$/i, ' in').replace(/ × /g, ' × '); }
  function plain(l) { return String(l || '').replace(/ IN$/i, ' in'); }

  var addBtn = $('[data-jp-design-add]');
  var own = addBtn ? String(addBtn.getAttribute('data-size') || '').toUpperCase() : '';
  var size = own;                         // the size the design goes into the set at
  var scale = null;                       // 3D controller once mounted
  var scaleSec = $('[data-jp-scale]');
  var T = function (k) { return scaleSec ? scaleSec.getAttribute('data-t-' + k) || '' : ''; };

  function spOf(label) { var z = J() && J().sizeFor(label); return z ? z.spaces : 0; }
  function spText(n) { return n === 1 ? T('sp1') : sub(T('sp'), { n: n }); }
  function product() {
    var d = root.dataset;
    return { id: d.jpProductId, productId: d.jpProductId, productHandle: d.jpProductHandle, title: d.jpProductTitle, image: d.jpProductImage,
      designCode: d.jpProductCode, style: d.jpProductStyle, description: d.jpProductDescription, sizeLabel: size,
      minimumSizeIn: d.jpMinimumSizeIn || null, artworkWidth: Number(d.jpArtworkWidth) || null, artworkHeight: Number(d.jpArtworkHeight) || null };
  }
  function inSet() {
    if (!window.JPState) return null;
    var h = root.dataset.jpProductHandle;
    return window.JPState.read().items.filter(function (x) { return x.productHandle === h; })[0] || null;
  }

  /* ---- size: one place that repaints everything that names it ---- */
  function applySize(label, anim) {
    if (!label) return;
    size = String(label).toUpperCase();
    var sp = spOf(size);
    var v = $('.szv'); if (v) v.textContent = nb(size);
    var s2 = $('.szs2'); if (s2 && sp) s2.textContent = spText(sp);
    var u = $('.usp'); if (u && sp) u.textContent = sp;
    var dz = $('.dsz'); if (dz && sp) dz.textContent = nb(size) + ' · ' + spText(sp);
    var h = scaleSec && $('.sch', scaleSec); if (h && T('h')) h.textContent = sub(T('h'), { size: nb(size) });
    paintAdd();
    if (scale) scale.size(anim);
    paintFill();
  }
  var szrow = $('[data-jp-size-change]');
  if (szrow) szrow.addEventListener('click', function () {
    if (!J() || !J().openSize) return;
    J().openSize(size, function (z) { if (z) applySize(z.label, true); });
  });

  /* ---- add to set ---- */
  var addTpl = addBtn ? addBtn.querySelector('span').textContent : '';
  function paintAdd() {
    if (!addBtn || !J()) return;
    var it = inSet(), span = addBtn.querySelector('span');
    addBtn.classList.toggle('done', !!it);
    if (it) {
      var left = J().cap() - J().used();
      span.textContent = left > 0 ? J().t('in_set', { left: left }) : J().t('in_set_full');
    } else {
      var sp = spOf(size);
      span.textContent = sp ? addTpl.replace(/·.*$/, '· ' + spText(sp)) : addTpl;
    }
  }
  if (addBtn) addBtn.addEventListener('click', function (e) {
    if (!J() || !window.JPState) return;              // no script: the link opens the editor
    e.preventDefault();
    if (inSet()) { J().toast(J().t('already')); return; }
    var z = J().sizeFor(size);
    J().add(product(), { size: z, src: $('.jpd-art img') });
  });

  /* ---- Save / Saved: the engine flips aria-pressed and the icon; the word follows ---- */
  $$('.jpd-like').forEach(function (b) {
    var sm = b.querySelector('small'); if (!sm) return;
    function lab() { sm.textContent = b.getAttribute('aria-pressed') === 'true' ? sm.getAttribute('data-saved-label') : sm.getAttribute('data-save-label'); }
    lab();
    if ('MutationObserver' in window) new MutationObserver(lab).observe(b, { attributes: true, attributeFilter: ['aria-pressed', 'class'] });
  });

  /* ---- Read more ---- */
  var desc = $('.jpd-desc'), more = $('.dmore');
  if (desc && more) {
    desc.classList.add('clamp');
    requestAnimationFrame(function () {
      if (desc.scrollHeight <= desc.clientHeight + 8) { desc.classList.remove('clamp'); return; }
      more.hidden = false;
      more.addEventListener('click', function () {
        var open = desc.classList.toggle('clamp') === false;
        desc.style.maxHeight = open ? desc.scrollHeight + 'px' : '';
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = more.getAttribute(open ? 'data-less' : 'data-more');
      });
    });
  }

  /* ---- set fill ---- */
  var fill = $('[data-jp-fill]');
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function paintFill() {
    if (!fill || !J() || !window.JPState) return;
    var st = window.JPState.read(), plan = J().plan(), cap = J().cap(), price = plan.priceLabel || fill.getAttribute('data-price');
    var me = inSet(), mySp = spOf(size) || Number(fill.getAttribute('data-sp')) || 0;
    var items = st.items.map(function (x) { return { img: J().img ? J().img(x, paintFill) : (x.previewUrl || x.image || ''), n: x.title || '', sp: Number(x.spaces) || 0, me: x === me, tx: x.sourceType === 'text' ? (x.text || x.title || '') : '' }; });
    if (!me) items.push({ img: root.dataset.jpProductImage, n: root.dataset.jpProductTitle, sp: mySp, me: true });
    var usedSp = items.reduce(function (a, x) { return a + x.sp; }, 0), left = cap - usedSp;
    var g = function (k) { return fill.getAttribute('data-t-' + k) || ''; };
    $('.fillh', fill).textContent = left < 0 ? g('full') : left === 1 ? sub(g('h1'), { price: price }) : sub(g('h'), { left: left, price: price });
    var hasSugg = !!$('[data-fsugg]', fill);
    $('.filld', fill).textContent = sub(hasSugg ? g('d') : g('d0'), { sp: mySp, cap: cap, series: fill.getAttribute('data-series') });
    $('.flbl', fill).textContent = sub(g('lbl'), { cap: cap });
    $('.fprc', fill).textContent = price;
    $('[data-ftrack]', fill).innerHTML = items.map(function (x) {
      var w = Math.min(1, x.sp / cap) * 100;
      var inner = x.img ? '<img src="' + esc(x.img) + '" alt="' + esc(x.n) + '">' : '';
      return '<div class="seg' + (x.me ? ' me' : '') + (x.tx && !x.img ? ' tx' : '') + '" style="width:calc(' + w.toFixed(2) + '% - 4px)">' + (inner || esc(x.tx)) + '<em>' + x.sp + '</em></div>';
    }).join('') + (left > 0 ? '<div class="rest">' + sub(g('left'), { n: left }) + '</div>' : '');
    $$('[data-fsugg] .pin', fill).forEach(function (c) { var n = Number(c.getAttribute('data-sp')) || 0; c.classList.toggle('nofit', n > Math.max(0, left)); });
  }

  /* ---- How big is …: chips, the still, and the 3D body ---- */
  function chip(id) { return scaleSec && $('.pls .chip[data-p="' + id + '"]', scaleSec); }
  function zoneWords(id) {
    if (!scaleSec) return;
    var c = chip(id); if (!c) return;
    var label = c.getAttribute('data-label'), d = String(c.getAttribute('data-days') || '').split('|');
    $$('.pls .chip', scaleSec).forEach(function (x) { var on = x === c; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    $('.locn', scaleSec).textContent = label;
    var Z = window.JPBody3D && window.JPBody3D.ZONES[id];
    $('.locl', scaleSec).textContent = Z ? Z.d : '';
    $('.pln', scaleSec).textContent = label;
    var pld = $('.pld', scaleSec), plr = $('.plr', scaleSec);
    var est = c.getAttribute('data-est') === '1';
    if (d.length === 2) {
      pld.textContent = sub(T('lasts'), { a: d[0], b: d[1] }) + (est && T('est') ? ' · ' + T('est') : '');
      plr.style.left = (d[0] / 22 * 100) + '%'; plr.style.width = ((d[1] - d[0]) / 22 * 100) + '%';
      var wd = document.querySelector('.jpd .wdek'), wk = est && T('wdek-est') ? 'wdek-est' : 'wdek';
      if (wd && T(wk)) wd.textContent = sub(T(wk), { a: d[0], b: d[1], place: label.toLowerCase() });
    } else { pld.textContent = ''; plr.style.width = '0'; }
  }
  var pz = size, zone = scaleSec ? scaleSec.getAttribute('data-first') : '';
  function sizeWords() {
    if (!scaleSec || !J()) return;
    var wh = inches(pz), sp = spOf(pz), c = chip(zone);
    var ts = J().tiers(), cap0 = (ts[0] || { cap: 15 }).cap;
    $('.szrv', scaleSec).textContent = nb(pz);
    if (sp) $('.szrs', scaleSec).textContent = sp <= cap0 ? sub(T('fit'), { spaces: spText(sp), fit: Math.floor(cap0 / sp), cap: cap0 })
      : sub(T('fit-more'), { spaces: spText(sp), cap: (ts.filter(function (x) { return x.cap >= sp; })[0] || ts[ts.length - 1] || { cap: '' }).cap });
    var use = $('.szuse', scaleSec);
    use.hidden = pz === size; use.textContent = sub(T('use'), { size: nb(pz) });
    if (!c) return;
    var zw = Number(c.getAttribute('data-w')) || 0, nm = c.getAttribute('data-label').toLowerCase(), r = zw ? wh[0] / zw : 0;
    var like = window.JPBody3D ? window.JPBody3D.sizeLike(wh[0], wh[1]) : '';
    var cmp = $('.pcmp', scaleSec);
    if (like) cmp.textContent = sub(T('cmp'), { size: plain(pz), like: like }) + (r > 0.92 || !r ? '' : sub(T('cov'), { part: r < 0.35 ? 'a small part of' : r < 0.65 ? 'about half' : 'most of', place: nm })) + '.';
    var warn = $('.pwarn', scaleSec);
    if (r > 0.92) {
      var flat = $$('.pls .chip', scaleSec).filter(function (x) { return x !== c && wh[0] <= (Number(x.getAttribute('data-w')) || 0) * 0.92; })
        .map(function (x) { return x.getAttribute('data-label').toLowerCase(); }).slice(0, 3);
      warn.hidden = false;
      warn.textContent = sub(T('wrap'), { size: plain(pz), place: nm, w: zw }) + (flat.length ? sub(T('flat'), { list: flat.join(', ').replace(/, ([^,]*)$/, ' or $1') }) : '');
    } else warn.hidden = true;
  }
  function group() { return J() && J().group ? J().group(size) : []; }
  function syncRuler() {
    if (!scaleSec) return;
    var ri = $('.szri', scaleSec), g = group();
    ri.max = String(Math.max(0, g.length - 1));
    ri.value = String(Math.max(0, g.map(function (z) { return z.label; }).indexOf(pz)));
    ri.disabled = g.length < 2;
  }
  /* the 2D still: the design drawn at true size on the photo of the first placement */
  function still() {
    var d = scaleSec && $('.jps-d', scaleSec); if (!d) return;
    var wh = inches(pz), first = chip(scaleSec.getAttribute('data-first'));
    var k = window.JPBody3D && window.JPBody3D.ZONES[scaleSec.getAttribute('data-first')] ? window.JPBody3D.ZONES[scaleSec.getAttribute('data-first')].k : 0;
    if (!k && first) return;
    d.style.setProperty('--bw', (wh[0] * 112.5 / k).toFixed(2) + '%');
    d.style.setProperty('--bh', (wh[1] * 100 / k).toFixed(2) + '%');
  }

  function mount() {
    if (!scaleSec || !window.JPBody3D) return;
    var api = window.JPBody3D, st = $('.stage', scaleSec), cv = $('canvas.b3', st), spots = $('.b3spots', st), lbl = $('.b3lbl', st), zb = $('.bmz', st), lg = $('.bml', st), hint = $('.bmh', st), model = $('.b3m', st);
    var zoomed = false, touched = false, pv = 0;
    cv.hidden = false;
    var B = api.Body3D(cv, { zones: api.ZONES, dur: function (ms) { return calm ? 1 : ms; }, isZoomed: function () { return zoomed; },
      onTouch: function () { touched = true; hint.classList.add('off'); }, onFrame: function () { overlay(); } });
    if (!B) { cv.hidden = true; st.classList.add('nogl'); return; }
    window.__b3 = window.__b3 || []; window.__b3.push(B); if (window.__b3.length > 5) window.__b3.shift().lose();
    st.classList.add('on3d');
    lg.hidden = false; hint.hidden = false;
    spots.innerHTML = $$('.pls .chip', scaleSec).map(function (c) { return '<button type="button" class="b3s" data-p="' + c.getAttribute('data-p') + '" aria-label="' + c.getAttribute('data-label') + '"><i></i></button>'; }).join('');
    function overlay() {
      var W = cv.clientWidth, H = cv.clientHeight;
      $$('.b3s', spots).forEach(function (b) {
        var an = B.anchor(b.getAttribute('data-p')), q = B.project(an[0]), face = B.facing(an[0], an[1]);
        var vis = !zoomed && face > 0.2 && q[0] > 8 && q[0] < W - 8 && q[1] > 8 && q[1] < H - 8;
        b.style.transform = 'translate(' + q[0].toFixed(1) + 'px,' + q[1].toFixed(1) + 'px)';
        b.classList.toggle('vis', vis); b.classList.toggle('sel', b.getAttribute('data-p') === zone);
      });
      if (zoomed && zone) {
        var p = B.anchor(zone)[0], wh = inches(pz), q = B.project([p[0], p[1] + wh[1] / 2 + 0.35, p[2]]);
        lbl.hidden = false; lbl.textContent = nb(pz); lbl.style.transform = 'translate(' + q[0].toFixed(1) + 'px,' + q[1].toFixed(1) + 'px)';
      } else lbl.hidden = true;
    }
    function ui() { zb.hidden = !zoomed; lg.classList.toggle('off', zoomed); hint.classList.toggle('off', zoomed || touched); model.classList.toggle('off', zoomed); overlay(); }
    function go(id, anim) { zone = id; zoneWords(id); sizeWords(); zoomed = true; ui(); return Promise.resolve(B.focus(id, anim && !calm ? 900 : 1)).then(overlay); }
    function whole(anim) { zoomed = false; ui(); return Promise.resolve(B.whole(anim && !calm ? 760 : 1)).then(overlay); }
    spots.addEventListener('click', function (e) { var b = e.target.closest('.b3s'); if (!b) return; touched = true; go(b.getAttribute('data-p'), true); });
    zb.addEventListener('click', function () { touched = true; whole(true); });
    function best() { var m = Math.max.apply(null, inches(size)); return m <= 1.2 ? 'wrist' : m <= 3.2 ? 'forearm' : m <= 4.5 ? 'upperarm' : m <= 6.5 ? 'thigh' : 'upperback'; }
    B.setImage(root.dataset.jpProductImage || scaleSec.getAttribute('data-image'));
    var wh = inches(pz); B.setSize(wh[0], wh[1]);
    zone = scaleSec.getAttribute('data-first') || best(); B.setZone(zone); zoneWords(zone); sizeWords(); ui();
    var seen = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return; seen.disconnect(); if (touched) return;
        setTimeout(function () { if (touched) return; Promise.resolve(calm ? 0 : B.sway()).then(function () { if (!touched) go(zone, true); }); }, calm ? 0 : 350);
      });
    }, { threshold: 0.55 }) : null;
    if (seen) seen.observe(st);
    var rz = 0; window.addEventListener('resize', function () { if (rz) return; rz = requestAnimationFrame(function () { rz = 0; B.draw(); overlay(); }); });
    scale = {
      place: function (id) { touched = true; return go(id, true); },
      preview: function (z) { pz = z; sizeWords(); if (pv) return; pv = requestAnimationFrame(function () { pv = 0; var w = inches(pz); B.setSize(w[0], w[1]); if (zoomed) B.refocus(420); }); },
      size: function () { scale.preview(size); syncRuler(); }
    };
  }
  if (scaleSec) {
    $$('.pls .chip', scaleSec).forEach(function (c) {
      c.addEventListener('click', function () {
        var id = c.getAttribute('data-p');
        if (scale) scale.place(id); else { zone = id; zoneWords(id); sizeWords(); }
      });
    });
    var ri = $('.szri', scaleSec);
    ri.addEventListener('input', function () {
      var z = group()[+ri.value]; if (!z) return;
      if (scale) scale.preview(z.label); else { pz = z.label; sizeWords(); still(); }
    });
    $('.szuse', scaleSec).addEventListener('click', function () { applySize(pz, true); });
    var loaded = false;
    function load() {
      if (loaded) return; loaded = true;
      var later = window.requestIdleCallback || function (f) { return setTimeout(f, 50); };
      if (window.JPBody3D) { later(mount, { timeout: 1500 }); return; }
      document.addEventListener('justpress:body3d-ready', function () { later(function () { mount(); sizeWords(); }, { timeout: 1500 }); }, { once: true });
      var s = document.createElement('script'); s.src = scaleSec.getAttribute('data-src'); s.async = true; document.head.appendChild(s);
    }
    /* fetch the 3D file once the page has settled (idle), or earlier when the section comes near */
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
    if (document.readyState === 'complete') idle(load, { timeout: 4000 }); else window.addEventListener('load', function () { idle(load, { timeout: 4000 }); });
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { near.disconnect(); load(); } }, { rootMargin: '900px 0px' });
      near.observe(scaleSec);
    } else load();
  }

  function init() {
    if (scaleSec) { syncRuler(); sizeWords(); }
    paintAdd(); paintFill();
  }
  document.addEventListener('justpress:state-change', function () { paintAdd(); paintFill(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Space pack gallery dots (phone): follow the swipe */
(function () {
  'use strict';
  var g = document.querySelector('[data-jpk-gal]'), dots = document.querySelectorAll('.jpk .gdots i');
  if (!g || !dots.length) return;
  var t = 0;
  g.addEventListener('scroll', function () {
    if (t) return;
    t = requestAnimationFrame(function () {
      t = 0;
      var f = g.querySelectorAll('.jpk-g'), w = f[1] ? f[1].offsetLeft - f[0].offsetLeft : 1, i = Math.round(g.scrollLeft / w);
      Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('on', k === i); });
    });
  }, { passive: true });
})();
